import { extractRawText } from 'mammoth'

export async function readDocumentLikeFile(file: File): Promise<string> {
  const name = file.name.toLowerCase()
  if (name.endsWith('.docx') || name.endsWith('.doc')) {
    const arrayBuffer = await file.arrayBuffer()
    const result = await extractRawText({ arrayBuffer })
    return result.value
  }
  return file.text()
}
